import { Clear } from "@mui/icons-material";
import { Box, Button, Grid, IconButton, Link } from "@mui/material";
import { useState } from "react";

export default function FeatureBox({
  title,
  description,
  color,
  imgSrc,
  imgClassName,
  buttonComponent,
  extraButtonComponent,
}) {
  return (
    <div
      className="dlcFeatureBoxContainer"
      style={{ backgroundColor: color + "1F" }}
      direction={{ xs: "column-reverse", md: "row" }}
    >
      {/* <Grid item container xs={12} md={9} lg={8} sx={{ paddingTop: { xs: 0, md: "24px" }, padding: "24px" }} gap={2}> */}
      <div className="dlcFeatureBoxInfoContainer">
        <h2 style={{ color: color }}>{title}</h2>
        <div>{description}</div>
        <div className="dlcFeatureBoxButtonContainer">
          {buttonComponent}
          {extraButtonComponent}
        </div>
      </div>
      {/* <Grid item xs={12} md={3} lg={4}> */}
      <div className="dlcFeatureBoxImageContainer">
        <img src={imgSrc} alt="" className={imgClassName} />
      </div>
    </div>
  );
}
